import { IPublicClientApplication } from '@azure/msal-browser';
import { ResourceTicketRequest } from '../../models/resource-services';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { getResource, postResourceTicket } from './index';

export const createResourcesApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  postResourceTicket: (instance: IPublicClientApplication, request: ResourceTicketRequest) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => postResourceTicket(fetchContext, request, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('postResourceTicket', isInFlight);
    },
  ),
  getResource: (instance: IPublicClientApplication, request: ResourceTicketRequest) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getResource(fetchContext, request, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getResource', isInFlight);
    },
  ),
});
